import { IsNumber, IsString } from "class-validator";
import { Expose } from "class-transformer";

export default class OrderItemHistoryListItem {
  @IsString()
  @Expose()
  itemName!: string;
  @IsString()
  @Expose()
  documentNumber!: string;
  @IsString()
  @Expose()
  documentItemIndex!: string;
  @IsNumber()
  @Expose()
  netValue!: number;
  @IsNumber()
  @Expose()
  purchaseNetPrice!: number;
  @IsNumber()
  @Expose()
  profit!: number;
  @IsNumber()
  @Expose()
  gross!: number;
}
